import React, { useEffect } from "react";

import { AppLoader } from "../../common/components/AppLoader";

interface SigninCallbackProps {
    onCallback(): void;
}

export const SigninCallback: React.FunctionComponent<SigninCallbackProps> = (props: SigninCallbackProps) => {
    useEffect(() => {
        props.onCallback();
    }, []);

    return <AppLoader message="Authentication in progress..." />;
};
